import { useNavigate } from "react-router-dom";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetFooter } from "../ui/sheet";
import { Button } from "../ui/button";
import { Trash2, Minus, Plus, ShoppingBag } from "lucide-react";
import { useCart } from "../../context/CartContext";
import { money } from "../../lib/menu";

export const CartSheet = () => {
  const { items, open, setOpen, removeItem, updateQty, totalCents } = useCart();
  const navigate = useNavigate();

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent className="bg-black border-l border-neon-green/30 text-white w-full sm:max-w-md flex flex-col" data-testid="cart-sheet">
        <SheetHeader>
          <SheetTitle className="font-heading text-4xl text-neon-green uppercase tracking-wide neon-glow-green flex items-center gap-2">
            <ShoppingBag /> Your Order
          </SheetTitle>
        </SheetHeader>

        <div className="flex-1 overflow-y-auto py-4 space-y-3">
          {items.length === 0 && (
            <p className="font-body text-neutral-500 text-center py-16" data-testid="cart-empty">Your cart is empty. Add some wings!</p>
          )}
          {items.map((it) => (
            <div key={it.lineId} data-testid="cart-line" className="border border-neon-green/20 p-4">
              <div className="flex justify-between items-start gap-3">
                <div className="flex-1">
                  <h4 className="font-heading text-xl text-white uppercase tracking-wide">{it.name}</h4>
                  {it.options?.length > 0 && (
                    <ul className="mt-1 space-y-0.5">
                      {it.options.map((o, i) => (
                        <li key={i} className="font-body text-xs text-neutral-400">· {o}</li>
                      ))}
                    </ul>
                  )}
                </div>
                <button onClick={() => removeItem(it.lineId)} data-testid="cart-remove" className="text-neutral-500 hover:text-red-500 transition-colors"><Trash2 size={18} /></button>
              </div>
              <div className="flex items-center justify-between mt-3">
                <div className="flex items-center gap-2 border border-neon-green/30">
                  <button onClick={() => updateQty(it.lineId, -1)} className="p-1.5 text-neon-green hover:bg-neon-green/10"><Minus size={14} /></button>
                  <span className="font-heading w-6 text-center">{it.quantity}</span>
                  <button onClick={() => updateQty(it.lineId, 1)} className="p-1.5 text-neon-green hover:bg-neon-green/10"><Plus size={14} /></button>
                </div>
                <span className="font-heading text-xl text-neon-yellow">{money(it.unit_price_cents * it.quantity)}</span>
              </div>
            </div>
          ))}
        </div>

        {items.length > 0 && (
          <SheetFooter className="flex-col gap-3 sm:flex-col">
            <div className="flex justify-between items-baseline w-full border-t border-neon-green/20 pt-4">
              <span className="font-heading text-2xl uppercase text-white">Total</span>
              <span className="font-heading text-3xl text-neon-green neon-glow-green" data-testid="cart-total">{money(totalCents)}</span>
            </div>
            <Button
              onClick={() => { setOpen(false); navigate("/checkout"); }}
              data-testid="checkout-btn"
              className="w-full font-heading text-2xl tracking-wide bg-neon-green text-black hover:bg-neon-yellow py-6"
            >
              Checkout
            </Button>
          </SheetFooter>
        )}
      </SheetContent>
    </Sheet>
  );
};

export default CartSheet;
